// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"426b54ea","453":"cc554beb"}[chunkId] + ".chunk.js";
};